// extracted by mini-css-extract-plugin
export default {"ownerGroupToggle":"ParentAndChain_ownerGroupToggle__sNKlq","container":"ParentAndChain_container__vMTpL","chainLogo":"ParentAndChain_chainLogo__EFSE+"};